export default "__VITE_ASSET__948D4L9A__"